/**
 * Adds some `undefined` values for HTML props that were removed from React types, but are still being included in
 * some of our third-party library types (because they are outdated). For details, see:
 *
 * - placeholder: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/67170
 * - onPointerEnterCapture & onPointerLeaveCapture: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/68984
 *
 * To fix "for real", we need probably need to upgrade the libraries that are affected to hopefully pick up changes to
 * their prop type definitions that don't include these deprecated props.
 */ export const DEPRECATED_REACT_PROPS = {
};

//# sourceMappingURL=deprecated-react-props.js.map